// extracted by mini-css-extract-plugin
module.exports = {"messaging":"TabsHeader_messaging__jAPt2"};